import React, { useEffect } from 'react';
import translations from '../lang';
import ExperienceTimeline from '../components/ExperienceTimeline';

function Experience({ lang }) {
  console.log('lang:', lang);
  console.log('translations:', translations);

  // ✅ 顶层就是 translations.experienceData
  const expRawData = translations.experienceData || [];

  const experienceData = Array.isArray(expRawData)
    ? expRawData.map(exp => ({
        id: exp.id,
        date: exp.date[lang],
        description:exp.description[lang],
        title: exp.title[lang],
        tags: exp.tag[lang],
        sections: exp.sections?.map(section => ({
          heading: section.heading[lang],
          content: section.content[lang]
        })) || []
      }))
    : [];

  console.log('experienceData:', experienceData);

  // ✅ 顶层就是 translations.experienceTitle
  const experienceTitle = translations.experienceTitle?.[lang] || "实习经历";

useEffect(() => {
  const hash = window.location.hash;
  if (hash) {
    requestAnimationFrame(() => {
      const anchor = document.querySelector(hash);
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
}, []);
 

  return (
    <div>
      <ExperienceTimeline 
        title={experienceTitle}
        experiences={experienceData}
      />
    </div>
  );
}

export default Experience;

